import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//Projects
import {
  setPlayerEditingSRTData,
  setTableData,
  setVideoFPS,
} from "../../actions/transOperationActions";
import {
  Button,
  Header,
  Divider,
  Icon,
  Form,
  TextArea,
} from "semantic-ui-react";
class ExportView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      JsonData: "",
      projectTitle: "",
    };

    this.saveJson = this.saveJson.bind(this);
    this.encode = this.encode.bind(this);
    this.startDownload = this.startDownload.bind(this);
  }

  componentDidMount() {
    //確認資料index 跟專案資料
    let projectIndex = parseInt(this.props.match.params.tIndex, 10);
    const projectListDataString = localStorage.getItem("projectListData");
    //console.log(`this.projectListData ${projectListDataString}`)
    //取得本地資料
    let projectListData = JSON.parse(projectListDataString);
    if (projectListData !== null) {
      const projectData = projectListData[projectIndex];

      const { Project } = projectData;

      this.setState({ projectTitle: Project.fProjectTitle });
    }
  }

  componentWillReceiveProps(nextProps) {}

  downloadFile = async () => {
    const { myData } = this.state; // I am assuming that "this.state.myData"
    // is an object and I wrote it to file as
    // json
    const fileName = "file";
    const json = JSON.stringify(myData);
    const blob = new Blob([json], { type: "application/json" });
    const href = await URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = href;
    link.download = fileName + ".json";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  //轉換下載
  startDownload(stringArray, type) {
    //轉換下載
    // var blob = new Blob( [document.getElementById('myInput').value], {
    //     type: 'text/plain;charset=utf-8'
    // });
    var blob = new Blob([stringArray], {
      type: "application/json",
    });
    var url = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `${this.state.projectTitle}.${type}`);
    var event = document.createEvent("MouseEvents");
    event.initMouseEvent(
      "click",
      true,
      true,
      window,
      1,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null
    );
    link.dispatchEvent(event);
  }

  saveJson = (obj) => {
    var str = JSON.stringify(obj);
    // var data = this.encode( str );

    var blob = new Blob([str], {
      type: "text/plain;charset=utf-8",
    });

    var url = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "data.srt");
    var event = document.createEvent("MouseEvents");
    event.initMouseEvent(
      "click",
      true,
      true,
      window,
      1,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null
    );
    link.dispatchEvent(event);
  };

  encode = (s) => {
    var out = [];
    for (var i = 0; i < s.length; i++) {
      out[i] = s.charCodeAt(i);
    }
    return new Uint8Array(out);
  };

  render() {
    return (
      <div>
        <div>
          <Icon
            className="float-right"
            name={"cancel"}
            onClick={() => {
              this.props.closeExportView();
            }}
          />
        </div>


        <Divider horizontal>
          <Header as="h4">
            <Icon name="closed captioning" />
            Type
          </Header>
        </Divider>

        <Button
          className="mb-2"
          basic
          color="teal"
          onClick={() => {
            this.props.downloadTxtFile("txt");
            // this.props.closeExportView('txt');
          }}
        >
          txt
        </Button>

        <Button
          className="mb-2"
          basic
          color="teal"
          onClick={() => { 
            this.props.downloadTxtFile("srt"); 
          }}
        >
          srt
        </Button>
        <Button
          className="mb-2"
          basic
          color="teal"
          onClick={() => {
            // this.downloadTxtFile('srt');
            this.props.downloadTxtFile("vtt");
            // this.props.closeExportView('srt');
          }}
        >
          vtt
        </Button>
        <Button
          className="mb-2"
          basic
          color="teal"
          onClick={() => {
            // this.downloadTxtFile('srt');
            this.props.downloadTxtFile("smi");
            // this.props.closeExportView('srt');
          }}
        >
          smi
        </Button>
        <Button
          className="mb-2"
          basic
          color="teal"
          onClick={() => {
            // this.downloadTxtFile('srt');
            this.props.downloadTxtFile("ttml");
            // this.props.closeExportView('srt');
          }}
        >
          ttml
        </Button>
        <Button
          className="mb-2"
          basic
          color="teal"
          onClick={() => {
            // this.downloadTxtFile('srt');
            this.props.downloadTxtFile("xml_Flash");
            // this.props.closeExportView('srt');
          }}
        >
          xml (Flash)
        </Button>
        <Button
          className="mb-2"
          basic
          color="teal"
          onClick={() => {
            // this.downloadTxtFile('srt');
            this.props.downloadTxtFile("xml_Time");
            // this.props.closeExportView('srt');
          }}
        >
          xml (Time)
        </Button>
        <Button
          className="mb-2"
          basic
          color="teal"
          onClick={() => {
            // this.downloadTxtFile('srt');
            this.props.downloadTxtFile("dfxp");
            // this.props.closeExportView('srt');
          }}
        >
          dfxp
        </Button>
        <Button
          className="mb-2"
          basic
          color="teal"
          onClick={() => {
            // this.downloadTxtFile('srt');
            this.props.downloadTxtFile("sub");
            // this.props.closeExportView('srt');
          }}
        >
          MicroDVD .sub
        </Button>
        <Button
          className="mb-2"
          basic
          color="teal"
          onClick={() => {
            // this.downloadTxtFile('srt');
            this.props.downloadTxtFile("sbv");
            // this.props.closeExportView('srt');
          }}
        >
          SubViewer .sbv
        </Button>
        <Button
          className="mb-2"
          basic
          color="teal"
          onClick={() => {
            // this.downloadTxtFile('srt');
            this.props.downloadTxtFile("ssa");
            // this.props.closeExportView('srt');
          }}
        >
          SubStation Alpha .ssa
        </Button>

        <Divider horizontal>
          <Header as="h4">
            <Icon name="file alternate outline" />
            Preview
          </Header>
        </Divider>

        <Form>
          <TextArea
            id={"myInput"}
            placeholder="Preview"
            style={{ minHeight: 100 }}
            value={this.state.JsonData}
          />
        </Form>

        <Divider horizontal>
          <Header as="h4">
            <Icon name="Download" />
            Source
          </Header>
        </Divider>

        <Button
          basic
          color="teal"
          onClick={() => {
            this.props.downloadSource();
            // this.props.closeExportView('srt');
          }}
        >
          Download
        </Button>
      </div>
    );
  }
}

ExportView.propTypes = {};

const mapStateToProps = (state) => ({
  transOperation: state.transOperation,
  findOperation: state.findOperation,
  editTable: state.editTable,
});

export default connect(mapStateToProps, {
  setVideoFPS,
  setTableData,
  setPlayerEditingSRTData,
})(withRouter(ExportView));



// WEBPACK FOOTER //
// ./src/components/import/ExportView.js